<template>
  <CommonModalAutoHeight
    modalId="painCareInfoModal"
    :headerShow="false"
    @click-backdrop="closePainCareInfoModal">
    <div class="care__container" slot="body">
      <div class="care__header">
        <p class="header__title">지원 자격 안내</p>
        <i class="header__close" @click="closePainCareInfoModal" />
      </div>
      <p class="care__subtitle">자격에 맞는지 꼭 확인해주세요.</p>
      <p class="care__content">물리치료사/작업치료사 면허증 또는 재활 관련 자격증 등을 보유하고 정형외과 또는 재활 병원 등에서 실제 운동을 통한 통증 케어 경력이 있는 분들만 지원이 가능합니다.</p>
      <p class="care__button" @click="clickOk">확인 했습니다.</p>
    </div>
  </CommonModalAutoHeight>
</template>
<script>
import CommonModalAutoHeight from '@/components/common/CommonModalAutoHeight'
export default {
  name: 'PainCareInfoModal',
  components: {
    CommonModalAutoHeight
  },
  methods: {
    closePainCareInfoModal(){
      this.$emit('close-pain-care-info-modal')
    },
    clickOk(){
      this.$emit('click-ok')
    },
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
.care__container{padding: 0 24px;}
.care__header{
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header__title{
    font-size: 20px;
    font-weight: $medium;
  }
  .header__close{
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(https://dcse8twossp9.cloudfront.net/static/img/icon/close-black-24-px.svg) center no-repeat;
    cursor: pointer;
  }
}
.care__subtitle{
  font-size: 15px;
  color: #555555;
}
.care__content{
  font-size: 15px;
  margin: 24px 0;
}
.care__button{
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #e1e1e1;
  font-weight: $bold;
  cursor: pointer;
  margin-bottom: 24px;
  &::before{
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(https://dcse8twossp9.cloudfront.net/static/img/icon/check-gray.svg) center no-repeat;
  }
}
</style>